import { render, staticRenderFns } from "./htmlBrandButton.vue?vue&type=template&id=6cc9e37c"
import script from "./htmlBrandButton.vue?vue&type=script&lang=ts"
export * from "./htmlBrandButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports